import React from 'react';
import { CommonButton } from '@Components';
import { ModalContainer } from './style';
import { BLUE_WARNING_ICON } from '@Images';
import { IRetryAadharVerificationProps } from '../../utils/interface';

const RetryAadharVerification: React.FC<IRetryAadharVerificationProps> = (props) => {
  const { headingText, subHeadingText, submitButtonText } = props;
  return (
    <ModalContainer
      containerMarginTop={32}
      buttonTopMargin={16}
      buttonWidth={418}
      height={248}
      width={450}
    >
      <div className="modalBodyContainer">
        <div className="headerContainer">
          <img src={BLUE_WARNING_ICON} alt="logo" />
          <p className="aadharMobileNotLinked">{headingText}</p>
          <p className="linkAadhar">{subHeadingText}</p>
        </div>
        <CommonButton onClick={props?.handleTryAgain} text={submitButtonText} width={418} />
      </div>
    </ModalContainer>
  );
};

export default RetryAadharVerification;
